import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loading',
  template: `
  <!--<div class="loader"></div>-->
  <div class="carga">
    <img src="assets/images/loading.gif" />
  </div>
  `,
  styles: ['.carga { text-align: center; }']
})
export class LoadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
